export default "__VITE_PUBLIC_ASSET__4c92254f__"